import { Card, CardContent, Divider, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export interface DetailSectionProps {
  /** Section title (translated). */
  title: string;
  /** Optional right-aligned action in the section header (e.g. an Add button). */
  action?: ReactNode;
  children: ReactNode;
}

/**
 * A titled card section for detail pages: `Card` + `CardContent` with a
 * heading, an optional header action and a divider. Replaces the repeated
 * Card/CardContent/Divider scaffolding in the person/company detail pages
 * (issue #881).
 */
export function DetailSection({ title, action, children }: DetailSectionProps) {
  return (
    <Card>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="subtitle1" fontWeight={600}>
            {title}
          </Typography>
          {action}
        </Stack>
        <Divider sx={{ mt: 1, mb: 2 }} />
        {children}
      </CardContent>
    </Card>
  );
}
